export const dateTimeToLocaleString = (value: string) =>
    new Date(value).toLocaleDateString("ru", {day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit"});